// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_f4eb47a","container":"_bc8fc57","avatarContainer":"_3bbd2c8","avatar":"_0c0eb1e","remaining":"_8e3491e","tooltip":"_997e68c"};